import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "node" })
], -1)
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "timeline-title text-sm font-normal text-grey" }
const _hoisted_4 = { class: "timeline-desc text-sm font-normal text-grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logKondektur, (data, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "timeline pb-5"
        }, [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.moment(data.CreatedAt.toString()).format('DD MMMM YYYY')), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(data.UpdatedString), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}